import React from 'react';
import { Section } from './Shared';
export function About() {
  return <div className="bg-cream border-y border-beige-muted/50" data-id="element-32">
      <Section data-id="element-33">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-34">
          {/* Left — Image */}
          <div className="flex justify-center" data-id="element-35">
            <div className="bg-white rounded-2xl shadow-sm border border-beige-muted/30 p-4 relative" data-id="element-36">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-sage-light/50 rounded-full -z-10" data-id="element-37"></div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-gold-light/50 rounded-full -z-10" data-id="element-38"></div>
              <img src="https://cdn.magicpatterns.com/uploads/7Npg1o98nTq6KgyE5Tg6Ru/ChatGPT_Image_9_may_2026,_09_34_57_p.m..png" alt="Mamá con su bebé en casa, momento de juego cálido y natural" className="w-full max-w-md h-auto object-cover rounded-xl" data-id="element-39" />
            </div>
          </div>

          {/* Right — Text */}
          <div data-id="element-40">
            <span className="text-sm font-bold text-sage-dark uppercase tracking-[0.2em]" data-id="element-41">
              ¿Quiénes somos?
            </span>

            <h2 className="font-playfair text-3xl md:text-4xl text-charcoal leading-tight mt-3 mb-6" data-id="element-42">
              Creamos esta guía para acompañarte en el desarrollo de tu bebé sin
              presión ni culpa
            </h2>

            <div className="space-y-4 text-charcoal-light text-base md:text-lg leading-relaxed" data-id="element-43">
              <p data-id="element-44">
                Sabemos lo difícil que es querer estimular a tu bebé "de la
                manera correcta" y sentir que hay demasiada información,
                exigencias o culpa.
              </p>
              <p data-id="element-45">
                Por eso creamos{' '}
                <strong className="text-charcoal" data-id="element-46">
                  "Estimulación Temprana Inteligente desde Casa"
                </strong>
                : una guía práctica, amorosa y realista para ayudarte a
                acompañar el desarrollo de tu bebé con actividades simples,
                naturales y adaptadas a la vida real.
              </p>
              <div className="space-y-1 py-2" data-id="element-47">
                <p className="font-medium text-charcoal" data-id="element-48">
                  No necesitás ser experta.
                </p>
                <p className="font-medium text-charcoal" data-id="element-49">
                  No necesitás materiales caros.
                </p>
                <p className="font-medium text-charcoal" data-id="element-50">
                  No necesitás pasar horas haciendo actividades.
                </p>
              </div>
              <p className="italic font-playfair text-charcoal" data-id="element-51">
                Solo necesitás pequeños momentos de conexión que sí hacen la
                diferencia.
              </p>
              <p data-id="element-52">
                Más de cientos de mamás ya están usando esta guía para
                estimular, conectar y disfrutar más tiempo con sus bebés desde
                casa.
              </p>
            </div>

            {/* Badges */}
            <div className="flex flex-wrap gap-3 mt-8" data-id="element-53">
              <span className="bg-white border border-beige-muted/50 text-charcoal text-sm font-medium px-4 py-2 rounded-full shadow-sm" data-id="element-54">
                ✨ Actividades simples y reales
              </span>
              <span className="bg-white border border-beige-muted/50 text-charcoal text-sm font-medium px-4 py-2 rounded-full shadow-sm" data-id="element-55">
                🧠 Desarrollo integral
              </span>
              <span className="bg-white border border-beige-muted/50 text-charcoal text-sm font-medium px-4 py-2 rounded-full shadow-sm" data-id="element-56">
                🏡 Hecho para aplicar en casa
              </span>
              <span className="bg-white border border-beige-muted/50 text-charcoal text-sm font-medium px-4 py-2 rounded-full shadow-sm" data-id="element-57">
                💗 Más conexión, menos presión
              </span>
            </div>
          </div>
        </div>
      </Section>
    </div>;
}